import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import loginReducer from '../Features/Adminlogindata';
import agentmonitorReducer from '../Features/Getallagentsmonitors';
import allowIpReducer from '../Features/AllowIpData';
import changePasswordReducer from '../Features/Changepassword';
import smsGatewaysReducer from '../Features/SmsGatewaysdata'
import SmsgatewaylistReducer from '../Features/Smsgatewaylist';
import smtpGatewayReducer from '../Features/Smtpgatewaysdata'
import smtpGatewayViewReducer from '../Features/Smtpgatewaysviewdata'
import loadingReducer from '../Features/loadingSlice';
import smsCampaignReducer from '../Features/smscampaign/Smscampaign'
import smsGatewaynumberReducer from '../Features/smscampaign/smsgatewaynumbers'
import smsCampaignviewReducer from '../Features/smscampaign/Smscampaignview'
import smsCampaignListReducer from '../Features/smscampaignlist/smscampaignlist'
import smsCampaignListViewReducer from '../Features/smscampaignlist/Smscampaiglistnview'
import smsCampaignListReportReducer from '../Features/reports/Smscampaignlistreport'
import smsCampaignShortcutsReducer from '../Features/SmscampaignShortcuts/Smscampaignshortcuts'
import smsCampaignShortcutsViewReducer from '../Features/SmscampaignShortcuts/Smscampaignshortcutview'
import smsCampaignListReports from '../Features/Smscampaignreports/Smscampaignlist'
import smsCampaignListRportDawnlaod from '../Features/Smscampaignreports/Smscampaignreportdawnload'
import smtpCampaignReducer from '../Features/smtpcampaign/Smtpcampaign'
import smtpcampaignViewReducer from '../Features/smtpcampaign/Smtpcampaignview'
import smtpCampaignReportReducer from '../Features/Smtpcampaignreports/Smtpcampaignreports'
import smtpCampaignListRportDawnlaodReducer from '../Features/Smtpcampaignreports/Smtpcampaignreportdawnload'
import checkbalanceReducer from '../Features/Checkbalance'
import dashboard2Reducer from '../Features/Dashboard/Dashboard2_0'
import smscampaingwisereportsReducer from "../Features/reports/SmsCampaignWiseReports"
import duplicatenumbersReducer from "../Features/reports/Duplicatenumberreports"
import duplicatenumberreportdawnloadReducer from "../Features/reports/Duplicatenumberreportsdawnload"
import userlogsreportsReducer from "../Features/reports/Userlogsreports"
import userlogsreportsDawnload from "../Features/reports/Userlogsdawnload"
import flagkeywordReducer from "../Features/Flagkeyword"
import blocklistReducer from "../Features/Blocklist"


const store = configureStore({
    reducer: {
        login: loginReducer,
        agentmonitor: agentmonitorReducer,
        allowIp: allowIpReducer,
        changpassword: changePasswordReducer,
        smsgateways: smsGatewaysReducer,
        smsgatewaylist: SmsgatewaylistReducer,
        smtpgateways: smtpGatewayReducer,
        smtpgatewaysview: smtpGatewayViewReducer,
        loading: loadingReducer,
        smscampaign: smsCampaignReducer,
        smsgatewaynumber: smsGatewaynumberReducer,
        smscampaignview: smsCampaignviewReducer,
        smscampaignlist: smsCampaignListReducer,
        smscampaignlistview: smsCampaignListViewReducer,
        smscampaignlistreport: smsCampaignListReportReducer,
        smscampaignshortcuts: smsCampaignShortcutsReducer,
        smscampaignshortcutsview: smsCampaignShortcutsViewReducer,
        smscampaignlistreports: smsCampaignListReports,
        smscampaignreportdawnlaod: smsCampaignListRportDawnlaod,
        smtpcampaign: smtpCampaignReducer,
        smtpcampaignview: smtpcampaignViewReducer,
        smtpcampaignreports: smtpCampaignReportReducer,
        smtpcampaignreportsdawnload: smtpCampaignListRportDawnlaodReducer,
        checkbalance: checkbalanceReducer,
        dashboard2: dashboard2Reducer,
        smscampaignwisereports: smscampaingwisereportsReducer,
        duplicatenumberreports: duplicatenumbersReducer,
        duplicatenumberreportsdawnload: duplicatenumberreportdawnloadReducer,
        userlogsreports: userlogsreportsReducer,
        userlogsdawnload: userlogsreportsDawnload,
        flagkeyword: flagkeywordReducer,
        blocklist: blocklistReducer,
    },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
